import m from "./design-system.es280.js";
import a from "./design-system.es58.js";
import { resolveComponent as d, openBlock as h, createElementBlock as v, normalizeClass as u, createElementVNode as s, createVNode as n, createTextVNode as l, renderSlot as w } from "vue";
import b from "./design-system.es146.js";
/* empty css                    */
import p from "./design-system.es128.js";
const k = {
  name: "DsTabHeader",
  components: {
    Icon: a
  },
  inject: {
    emitter: {
      default() {
        return {
          on() {
          },
          off() {
          }
        };
      }
    }
  },
  props: {
    /**
     * Debounce delay for window resize hook
     */
    debounceDelay: {
      type: Number,
      default: 300,
      dimension: "milliseconds"
    }
  },
  setup() {
    const { isTouchDevice: o } = b();
    return {
      isTouchDevice: o
    };
  },
  data() {
    return {
      hasOverflow: !1
    };
  },
  created() {
    this.debounceDelay && (this.checkOverflow = m(this.checkOverflow, this.debounceDelay));
  },
  mounted() {
    this.checkOverflow(), window.addEventListener("resize", this.checkOverflow), this.emitter.on("TAB_HEADER_TABS_UPDATED", this.checkOverflow);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkOverflow), this.emitter.off("TAB_HEADER_TABS_UPDATED", this.checkOverflow);
  },
  methods: {
    checkOverflow() {
      this.$nextTick(() => {
        this.$refs.tablist && (this.hasOverflow = this.$refs.tablist.clientWidth < this.$refs.tablist.scrollWidth);
      });
    },
    moveLeft() {
      this.$refs.tablist.scrollLeft += -200;
    },
    moveRight() {
      this.$refs.tablist.scrollLeft += 200;
    }
  }
}, D = {
  ref: "tablist",
  class: "tablist tabs"
};
function T(o, e, O, c, f, t) {
  const i = d("Icon");
  return h(), v("div", {
    ref: "overflowContainer",
    class: u(["overflow-container", { "has-overflow": f.hasOverflow && !c.isTouchDevice }])
  }, [
    s("div", {
      class: "move move-left",
      onClick: e[0] || (e[0] = (...r) => t.moveLeft && t.moveLeft(...r))
    }, [
      n(i, { name: "chevron-left" })
    ]),
    e[2] || (e[2] = l()),
    s("div", {
      class: "move move-right",
      onClick: e[1] || (e[1] = (...r) => t.moveRight && t.moveRight(...r))
    }, [
      n(i, { name: "chevron-right" })
    ]),
    e[3] || (e[3] = l()),
    s("ul", D, [
      w(o.$slots, "default", {}, void 0, !0)
    ], 512)
  ], 2);
}
const C = /* @__PURE__ */ p(k, [["render", T], ["__scopeId", "data-v-54c9e58c"]]);
export {
  C as default
};
//# sourceMappingURL=design-system.es101.js.map
